// extracted by mini-css-extract-plugin
export default {"button":"K8W2xAVna2","title":"TZbD52mIJg","icon":"o_v2C5V78w","content":"IHxSdoUzaY","expanded":"yMoNmxZLWt"};